import { render } from "./ViewsSurveyDelivery.vue?vue&type=template&id=0c9f8ccc"
import script from "./ViewsSurveyDelivery.vue?vue&type=script&lang=js"
export * from "./ViewsSurveyDelivery.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__